import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const base = `${API}/api/customer-orders`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// ── Price Lists ───────────────────────────────────────────────────────────────
const getPriceLists = () => axios.get(`${base}/price-lists`, auth()).then(r => r.data);
const getPriceListByCustomer = (customerId) => axios.get(`${base}/price-lists/customer/${customerId}`, auth()).then(r => r.data);
const createPriceList = (data) => axios.post(`${base}/price-lists`, data, auth()).then(r => r.data);
const updatePriceList = (id, data) => axios.put(`${base}/price-lists/${id}`, data, auth()).then(r => r.data);
const addPriceListItem = (priceListId, data) => axios.post(`${base}/price-lists/${priceListId}/items`, data, auth()).then(r => r.data);
const updatePriceListItem = (itemId, data) => axios.put(`${base}/price-lists/items/${itemId}`, data, auth()).then(r => r.data);
const deletePriceListItem = (itemId) => axios.delete(`${base}/price-lists/items/${itemId}`, auth()).then(r => r.data);

// ── Orders ────────────────────────────────────────────────────────────────────
const getOrders = (params = {}) => axios.get(base, { ...auth(), params }).then(r => r.data);
const getOrder = (id) => axios.get(`${base}/${id}`, auth()).then(r => r.data);
const createOrder = (data) => axios.post(base, data, auth()).then(r => r.data);
const updateOrder = (id, data) => axios.put(`${base}/${id}`, data, auth()).then(r => r.data);
const transitionOrder = (id, status) => axios.post(`${base}/${id}/transition`, { status }, auth()).then(r => r.data);
const archiveOrder = (id) => axios.post(`${base}/${id}/archive`, {}, auth()).then(r => r.data);
const unarchiveOrder = (id) => axios.post(`${base}/${id}/unarchive`, {}, auth()).then(r => r.data);
const deleteOrder = (id) => axios.delete(`${base}/${id}`, auth()).then(r => r.data);
const acknowledgeOrder = (id) => axios.post(`${base}/${id}/acknowledge`, {}, auth()).then(r => r.data);
const getOrderEvents = (id) => axios.get(`${base}/${id}/events`, auth()).then(r => r.data);

// ── Delivery Assignment ───────────────────────────────────────────────────────
const assignDelivery = (id, employeeId) =>
  axios.put(`${base}/${id}/assign-delivery`, { employeeId }, auth()).then(r => r.data);

// ── Lot Codes ─────────────────────────────────────────────────────────────────
const getLotCodes    = (id) => axios.get(`${base}/${id}/lot-codes`, auth()).then(r => r.data);
const saveLotCodes   = (id, lotCodes) => axios.post(`${base}/${id}/lot-codes`, { lotCodes }, auth()).then(r => r.data);
const approveLotCodes = (id, lotCodes) => axios.post(`${base}/${id}/lot-codes/approve`, { lotCodes }, auth()).then(r => r.data);

// ── Customer Portal (no auth) ─────────────────────────────────────────────────
const getPortal = (token) => axios.get(`${base}/portal/${token}`).then(r => r.data);
const submitPortalOrder = (token, data) => axios.post(`${base}/portal/${token}/orders`, data).then(r => r.data);
const getPortalOrders = (token) => axios.get(`${base}/portal/${token}/orders`).then(r => r.data);
const submitCreditApp = (token, data) => axios.post(`${base}/portal/${token}/credit-app`, data).then(r => r.data);

// Reseller module (docs/RESELLER_MODULE.md) — returns 404 if this tenant isn't a reseller.
const getResellerParentCatalog = () => axios.get(`${base}/reseller/parent-catalog`, auth()).then(r => r.data);

const customerOrderService = {
  getPriceLists,
  getPriceListByCustomer,
  createPriceList,
  updatePriceList,
  addPriceListItem,
  updatePriceListItem,
  deletePriceListItem,
  getOrders,
  getOrder,
  createOrder,
  updateOrder,
  transitionOrder,
  deleteOrder,
  archiveOrder,
  unarchiveOrder,
  acknowledgeOrder,
  assignDelivery,
  getOrderEvents,
  getLotCodes,
  saveLotCodes,
  approveLotCodes,
  getPortal,
  submitPortalOrder,
  getPortalOrders,
  submitCreditApp,
  getResellerParentCatalog,
};

export default customerOrderService;
